module.exports = __webpack_public_path__ + "img/Anika Reinout.9cd95546.png";